import React, { Component } from 'react';


import NumberFormat from 'react-number-format';
import {transactionID, clientInfo} from '../../../services/helpers';
import axios from 'axios';
import Swal from 'sweetalert2';
import ChooseCreditCard from './ChooseCreditCard';
import AddCard from './AddCard';

import IconCreditCard from '../../../images/payments/iCredito.png';
import IconDebitCard from '../../../images/payments/iDebito.png';
import ImageCardFlags from '../../../images/payments/flags_credit.svg';




class ChoosePayment extends Component {

    constructor(props) {
        super(props);

        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo().accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

        this.state = {
            creditCardList: [],
            paymentType: '',
            chooseCreditCard: false
        }
    }

    handleLoading = (loading) => {
        this.props.setLoading(loading)
    }

    setPaymentType = (paymentType, chooseCreditCard = false) => {
        this.setState({paymentType, chooseCreditCard});
    }

    handlePayment = (payment) => {
        const {paymentType} = this.state;
        payment.type = paymentType;
        this.props.setPayment(payment);
        this.props.step(4);
    }

    componentDidMount = async () => {


    }

    render() {

        const {creditCardList, chooseCreditCard, paymentType} = this.state;

        return (
            <div className="choose-payment-method-container step">
                {
                    paymentType === '' &&
                
                    <div className="choose-method">
                        <h2>Selecione a forma de pagamento</h2>
                        <ul className="select-payment-method ">
                            <li onClick={() => { this.setPaymentType('C', true);  }}>
                                <div className="img-select-method">
                                    <img src={IconCreditCard} />
                                </div>
                                <div>
                                    <h4>Crédito</h4>
                                    <img className="payment-flags" src={ImageCardFlags} />
                                </div>
                                <div className="arrow-icon" href="#"></div>
                            </li>
                            <li onClick={() => { this.setPaymentType('D') }}>
                                <div className="img-select-method">
                                    <img src={IconDebitCard} />
                                </div>
                                <div>
                                    <h4>Débito</h4>
                                    <img className="payment-flags" src={ImageCardFlags} />
                                </div>
                                <div className="arrow-icon" href="#" ></div>
                            </li>
                        </ul>
                    </div>
                }

                {
                    (paymentType === 'C' && chooseCreditCard) &&
                    <ChooseCreditCard handleLoading={this.handleLoading} setPaymentType={this.setPaymentType} paymentType={paymentType} handlePayment={this.handlePayment}  />
                }

                {
                    (paymentType !== '' && !chooseCreditCard ) &&
                    <AddCard handleLoading={this.handleLoading} setPaymentType={this.setPaymentType} paymentType={paymentType} handlePayment={this.handlePayment}  />
                }
            </div>
        );
    }

}

export default ChoosePayment